import { Modal } from "@design-system/Modal";
import { Text } from "@design-system/Typography/Text";
import { type FC } from "react";
import { useSupplierQuestionsGroupSelectTranslations } from "./i18n";

export const QuestionGroupDeleteModal: FC<{
    open: boolean;
    onOpenChange: (open: boolean) => void;
    loading: boolean;
    onDelete: () => void;
}> = ({ open, onOpenChange, loading, onDelete }) => {
    const { t, keys } = useSupplierQuestionsGroupSelectTranslations();

    return (
        <Modal open={open} onOpenChange={onOpenChange}>
            <Modal.Overlay centerContent>
                <Modal.Content>
                    <Modal.Header>
                        <Modal.Title>{t(keys.modal_delete_title)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Text variant="body" color="primary">
                            {t(keys.modal_delete_body)}
                        </Text>
                    </Modal.Body>
                    <Modal.Footer>
                        <Modal.CancelCTA>
                            {t(keys.modal_cancel)}
                        </Modal.CancelCTA>
                        <Modal.ConfirmCTA
                            variant="flatDanger"
                            loading={loading}
                            onClick={onDelete}
                        >
                            {t(keys.modal_delete)}
                        </Modal.ConfirmCTA>
                    </Modal.Footer>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};
